<template>
    <div class="activity-photolist">
        <a-breadcrumb class="breadcrumb">
            <a-breadcrumb-item>您的位置:</a-breadcrumb-item>
            <a-breadcrumb-item><a href="/ActivityPhotos/list">活動照片</a></a-breadcrumb-item>
            <a-breadcrumb-item v-if="searchText" ><span v-text="`搜索：${searchText}`"></span></a-breadcrumb-item>
        </a-breadcrumb>
        <div class="content">
            <a-timeline mode="alternate" class="alternate">
                <a-timeline-item :color="data.color" v-for="(data, i) in dataList" :key=i>
                    <div class="timeline-box"></div>
                    <div class="content-box" :style="{'background-color': data.color}">
                        <router-link :to="`/ActivityPhotos/details/${data.id}`" class="container">
                            <div class="time" v-text="data.actdate"></div>
                            <div class="title" v-text="data.title"></div>
                            <div class="img-container">
                                <img :src="data.thumb" alt="">
                            </div>
                        </router-link>
                    </div>
                </a-timeline-item>
            </a-timeline>
        </div>
        <split-page v-if="visible" :initData="{pageNo, pageSize, total}" :onPageChanged="onPageChanged"/>
        <loading v-if="loading" />
    </div>
</template>

<script>
    import Loading from '../../components/Loading.vue'
    import SplitPage from '../../components/SplitPage.vue'
    export default {
        components: {
            Loading,
            SplitPage,
        },
        props: {
            keyword: null,
        },
        data(){
            return {
                kw: '',
                loading: false,
                searchText: '',
                dataList: [],
                pageNo: 1,
                pageSize: 20,
                total: 0,
                visible: false,
            }
        },
        mounted: function(){
            this.kw = this.keyword || this.$route.query.keyword || ''
            this.onRefresh()
        },
        methods: {
            onPageChanged: function(page) {

            },
            onRefresh: function(){
                this.loading = true
                this.$store.dispatch('getActivityPhotos', {
                    associationid: 4,
                    keyword: this.kw.trim() || undefined,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                }).then(rs=>{
                    this.loading = false
                    var list = rs.list || []
                    list.forEach(d=>d.color= `#${Math.floor(Math.random()*16777215).toString(16)}`)
                    this.dataList = list
                    this.total = rs.total || 0
                    this.visible = this.total > 0                    
                }).catch(error=>{
                    this.loading = false
                    this.$message.warning(error)
                })
            }
        },
        watch: {
            '$props.keyword': function(keyword) {
                if(keyword == null) {
                    return
                }
                this.kw = keyword || ''
                this.onRefresh()
            },
            '$route.query.keyword': function(keyword) {
                this.kw = keyword || ''
                this.onRefresh()
            },
        }
    }
</script>

<style >
    .activity-photolist {
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
    }

    .activity-photolist > .breadcrumb {
        height: 36px;
        line-height: 36px;
        padding: 0 12px;
        background-color: #fff;
    }

    .activity-photolist > .content {
        flex: 1;
        margin-top: 10px;
        background-color: #fff;
        border: 1px solid #e8e8e8;
        box-shadow: 1px 1px 1px #e9e7e7;
        padding: 0 8px;
    }

    .activity-photolist .alternate {
       padding-top: 170px;
       flex: 1;
    }

    .activity-photolist .timeline-box {
        width: 100%;
        height: 300px;
        position: relative;
    }

    .activity-photolist .content-box {
        width: 100%;
        height: 280px;
        position: absolute;
        top: -150px;
        border-radius: 40px;
        right: 0;
        box-sizing: border-box;
        padding: 20px;
        box-shadow: 2px 2px 5px #ccc;
    }

    .ant-timeline-item:nth-child(2n-1) .content-box {
        right: unset;
        left: 0;
    }

    .activity-photolist .content-box .container {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        background-color: #fff;
        border-radius: 12px;
        box-sizing: border-box;
        padding: 8px 12px;
        height: 100%;
    }

    .ant-timeline-item:nth-child(2n-1) .container {
        align-items: flex-start;
    }

    .activity-photolist .content-box .container .img-container {
        flex: 1;
        display: flex;
        overflow: hidden;
    }

    .activity-photolist .content-box .container .img-container img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .activity-photolist .content-box .container .title {
        height: 36px;
        line-height: 36px;
        font-size: 18px;
        font-weight: bold;
        color: #1f1f1f;
    }

    .activity-photolist .content-box .container .time {
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #666;
    }

    @media only screen and (max-width: 1050px) {
        .ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content {
            left: unset;
            width: unset;
        }
    }
</style>
